import { render, staticRenderFns } from "./passForbiden.vue?vue&type=template&id=19fd2fd0&scoped=true"
import script from "./passForbiden.vue?vue&type=script&lang=js"
export * from "./passForbiden.vue?vue&type=script&lang=js"
import style0 from "./passForbiden.vue?vue&type=style&index=0&id=19fd2fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd2fd0",
  null
  
)

export default component.exports